/* Maison Boutique — scripts du thème (sans dépendance) */
(function () {
  'use strict';

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  function money(cents) {
    try {
      return new Intl.NumberFormat(window.theme.locale || undefined, {
        style: 'currency',
        currency: window.theme.currency || 'EUR'
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  /* ---------- Menu mobile + recherche (délégation : survit à l'éditeur de thème) ---------- */
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-menu-open]');
    var close = e.target.closest('[data-menu-close]');
    var search = e.target.closest('[data-search-toggle]');

    if (open) {
      var drawer = $('[data-drawer]');
      if (drawer) { drawer.hidden = false; document.body.classList.add('no-scroll'); }
    }
    if (close) {
      var d = $('[data-drawer]');
      if (d) { d.hidden = true; document.body.classList.remove('no-scroll'); }
    }
    if (search) {
      var panel = $('[data-search-panel]');
      if (panel) {
        panel.hidden = !panel.hidden;
        if (!panel.hidden) { var input = $('input[type="search"]', panel); if (input) input.focus(); }
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var d = $('[data-drawer]');
      if (d && !d.hidden) { d.hidden = true; document.body.classList.remove('no-scroll'); }
    }
  });


  /* ---------- Panier tiroir ---------- */
  var cartBusy = false;
  function cartRoot() { return (window.theme && window.theme.routes && window.theme.routes.root) || '/'; }
  function cartDrawerEl() { return $('[data-cart-drawer]'); }
  function openCart() {
    var d = cartDrawerEl();
    if (!d) return false;
    d.hidden = false;
    document.body.classList.add('no-scroll');
    requestAnimationFrame(function () { d.classList.add('is-open'); });
    return true;
  }
  function closeCart() {
    var d = cartDrawerEl();
    if (!d) return;
    d.classList.remove('is-open');
    document.body.classList.remove('no-scroll');
    setTimeout(function () { if (!d.classList.contains('is-open')) d.hidden = true; }, 250);
  }
  function refreshCart() {
    return fetch(cartRoot() + '?sections=cart-drawer', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data && data['cart-drawer'];
        var cur = cartDrawerEl();
        if (!html || !cur) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = $('[data-cart-drawer]', doc);
        if (!fresh) return;
        cur.innerHTML = fresh.innerHTML;
        cur.setAttribute('data-count', fresh.getAttribute('data-count') || '0');
        var count = parseInt(fresh.getAttribute('data-count') || '0', 10);
        $$('[data-cart-count]').forEach(function (el) { el.textContent = count; el.classList.toggle('is-empty', count === 0); });
      });
  }
  document.addEventListener('click', function (e) {
    var cartLink = e.target.closest('.header__cart');
    if (cartLink && !document.body.classList.contains('template-cart') && cartDrawerEl()) {
      e.preventDefault();
      refreshCart().then(openCart, openCart);
      return;
    }
    if (e.target.closest('[data-cart-close]')) { closeCart(); return; }
    var q = e.target.closest('[data-cart-qty]');
    if (q) {
      var li = q.closest('[data-line]');
      if (!li || cartBusy) return;
      cartBusy = true;
      var drawer = cartDrawerEl();
      if (drawer) drawer.classList.add('is-busy');
      fetch(cartRoot().replace(/\/$/, '') + '/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: parseInt(li.getAttribute('data-line'), 10), quantity: Math.max(0, parseInt(q.getAttribute('data-cart-qty'), 10)) })
      }).then(function () { return refreshCart(); })
        .catch(function () {})
        .then(function () { cartBusy = false; var d = cartDrawerEl(); if (d) d.classList.remove('is-busy'); });
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCart();
  });
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-product-form]') || !cartDrawerEl()) return;
    var submitter = e.submitter;
    if (submitter && submitter.name === 'checkout') return;
    e.preventDefault();
    var btn = form.querySelector('[data-add-btn]');
    if (btn) btn.disabled = true;
    fetch(window.theme.routes.cartAdd, {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    }).then(function (r) {
      if (!r.ok) throw new Error('add');
      return refreshCart();
    }).then(function () {
      if (btn) btn.disabled = false;
      openCart();
    }).catch(function () {
      if (btn) btn.disabled = false;
      form.submit();
    });
  });

  /* ---------- Filtres / tri de collection ---------- */
  document.addEventListener('change', function (e) {
    var el = e.target.closest('[data-auto-submit]');
    if (!el) return;
    var form = document.getElementById(el.getAttribute('form'));
    if (form) {
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    }
  });

  /* ---------- Fiche produit ---------- */
  function initProduct(section) {
    if (section.__productReady) return;
    section.__productReady = true;

    var jsonEl = $('[data-product-json]', section);
    var form = $('[data-product-form]', section);
    if (!jsonEl || !form) return;

    var product = JSON.parse(jsonEl.textContent);
    var idInput = $('[data-variant-id]', form);
    var addBtn = $('[data-add-btn]', form);
    var qtyInput = $('[data-qty-input]', form);
    var priceNow = $('[data-price-now]', section);
    var priceCompare = $('[data-price-compare]', section);
    var priceBadge = $('[data-price-badge]', section);
    var bundle = $('[data-bundle]', section);
    var currentVariant = null;

    function selectedOptions() {
      return $$('[data-option-index]', form).map(function (fs) {
        var checked = $('input:checked', fs);
        return checked ? checked.value : null;
      });
    }

    function findVariant(opts) {
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return opts[i] === o; });
      });
    }

    $$('[data-ship-date]', section).forEach(function (el) {
      try {
        var d = new Date(el.getAttribute('data-ship-date') + 'T12:00:00');
        el.textContent = new Intl.DateTimeFormat(document.documentElement.lang || 'fr', { weekday: 'short', day: 'numeric', month: 'short' }).format(d);
      } catch (e) {}
    });

    function updateGallery(variant) {
      var mediaId = variant && variant.featured_media && variant.featured_media.id;
      if (!mediaId) return;
      showMedia(mediaId);
    }

    function showMedia(id) {
      $$('.gallery__slide', section).forEach(function (s) {
        s.classList.toggle('is-active', String(s.getAttribute('data-media-id')) === String(id));
      });
      $$('.gallery__thumb', section).forEach(function (t) {
        var on = String(t.getAttribute('data-thumb')) === String(id);
        t.classList.toggle('is-active', on);
        var box = t.parentNode;
        if (on && box && box.scrollHeight > box.clientHeight + 1 && box.scrollWidth <= box.clientWidth + 1) {
          box.scrollTop = t.offsetTop - box.offsetTop - 4;
        } else if (on && box && box.scrollWidth > box.clientWidth + 1) {
          box.scrollLeft = t.offsetLeft - box.offsetLeft - 4;
        }
      });
    }

    function updatePrice(variant) {
      if (!variant) return;
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (priceNow) {
        priceNow.textContent = money(variant.price);
        priceNow.classList.toggle('price__sale', !!onSale);
      }
      if (priceCompare) {
        priceCompare.hidden = !onSale;
        if (onSale) priceCompare.textContent = money(variant.compare_at_price);
      }
      if (priceBadge) {
        priceBadge.hidden = !onSale;
        if (onSale) priceBadge.textContent = '-' + Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '%';
      }
    }

    function updateBundle(variant) {
      if (!bundle || !variant) return;
      $$('[data-bundle-qty]', bundle).forEach(function (input) {
        var qty = parseInt(input.getAttribute('data-bundle-qty'), 10);
        var disc = parseFloat(input.getAttribute('data-bundle-discount')) || 0;
        var orig = variant.price * qty;
        var total = Math.round(orig * (100 - disc) / 100);
        var box = input.nextElementSibling;
        var totalEl = $('[data-bundle-total]', box);
        var origEl = $('[data-bundle-orig]', box);
        if (totalEl) totalEl.textContent = money(total);
        if (origEl) origEl.textContent = money(orig);
      });
    }

    function updateButton(variant) {
      if (!addBtn) return;
      if (!variant) {
        addBtn.disabled = true;
        addBtn.textContent = 'Indisponible';
      } else if (!variant.available) {
        addBtn.disabled = true;
        addBtn.textContent = addBtn.getAttribute('data-soldout') || 'Épuisé';
      } else {
        addBtn.disabled = false;
        addBtn.textContent = addBtn.getAttribute('data-label') || 'Ajouter au panier';
      }
    }

    function onVariantChange() {
      var opts = selectedOptions();
      var variant = findVariant(opts);
      currentVariant = variant || null;

      $$('[data-option-index]', form).forEach(function (fs, i) {
        var label = $('[data-option-selected]', fs);
        if (label && opts[i]) label.textContent = opts[i];
      });

      if (idInput) {
        if (variant) { idInput.value = variant.id; idInput.disabled = false; } else { idInput.disabled = true; }
      }
      $$('[data-stock-variant]', section).forEach(function (el) { el.hidden = !(variant && String(el.getAttribute('data-stock-variant')) === String(variant.id)); });
      updatePrice(variant);
      updateBundle(variant);
      updateButton(variant);
      updateGallery(variant);

      if (variant && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    form.addEventListener('change', function (e) {
      if (e.target.closest('[data-option-index]')) onVariantChange();
    });

    /* Quantité */
    function setQty(n) {
      if (!qtyInput) return;
      n = Math.max(1, parseInt(n, 10) || 1);
      qtyInput.value = n;
      syncBundleFromQty(n);
    }

    function syncBundleFromQty(n) {
      if (!bundle) return;
      var match = null;
      $$('[data-bundle-qty]', bundle).forEach(function (input) {
        if (parseInt(input.getAttribute('data-bundle-qty'), 10) === n) match = input;
      });
      $$('[data-bundle-qty]', bundle).forEach(function (input) { input.checked = (input === match); });
    }

    var minus = $('[data-qty-minus]', form);
    var plus = $('[data-qty-plus]', form);
    if (minus) minus.addEventListener('click', function () { setQty((parseInt(qtyInput.value, 10) || 1) - 1); });
    if (plus) plus.addEventListener('click', function () { setQty((parseInt(qtyInput.value, 10) || 1) + 1); });
    if (qtyInput) qtyInput.addEventListener('change', function () { setQty(qtyInput.value); });

    /* Bundle : choisir un palier règle la quantité */
    if (bundle) {
      bundle.addEventListener('change', function (e) {
        var input = e.target.closest('[data-bundle-qty]');
        if (!input || !qtyInput) return;
        qtyInput.value = input.getAttribute('data-bundle-qty');
      });
    }

    /* Vignettes */
    $$('[data-thumb]', section).forEach(function (btn) {
      btn.addEventListener('click', function () { showMedia(btn.getAttribute('data-thumb')); });
    });

    /* Valeur initiale */
    onVariantChange();
  }

  function initAllProducts() { $$('[data-product-section]').forEach(initProduct); }

  /* ---------- Produits recommandés ---------- */
  function initRecommendations() {
    $$('[data-recommendations]').forEach(function (el) {
      if (el.__loaded) return;
      el.__loaded = true;
      var url = el.getAttribute('data-url');
      if (!url) return;
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-recommendations]');
          if (fresh && fresh.innerHTML.trim().length) el.innerHTML = fresh.innerHTML;
        })
        .catch(function () {});
    });
  }

  /* ---------- Carrousels ---------- */
  function initCarousels() {
    $$('[data-carousel]').forEach(function (el) {
      if (el.__carousel) return;
      el.__carousel = true;
      var track = $('[data-carousel-track]', el);
      var prev = $('[data-carousel-prev]', el);
      var next = $('[data-carousel-next]', el);
      if (!track) return;
      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
      }
      function go(dir) { track.scrollBy({ left: dir * track.clientWidth * 0.9, behavior: 'smooth' }); }
      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  function boot() { initAllProducts(); initRecommendations(); initCarousels(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  /* Éditeur de thème : réinitialiser quand une section est rechargée */
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target;
    $$('[data-product-section]', root).forEach(function (s) { s.__productReady = false; });
    if (root.matches && root.matches('[data-product-section]')) root.__productReady = false;
    $$('[data-recommendations]', root).forEach(function (r) { r.__loaded = false; });
    boot();
  });
})();
